module.exports = __webpack_public_path__ + "img/application.1de6cdec.svg";